import { Row } from "@tanstack/react-table";
import { ChevronDown, ChevronRight } from "lucide-react";
import { ReactNode } from "react";

interface ActionCellProps<T> {
  row: Row<T>;
  children?: ReactNode;
}

export const ActionCell = function ActionCell<T>({ row, children }: ActionCellProps<T>) {
  const isExpandable = row.getCanExpand();
  const hasSubRows = row.subRows.length > 0;
  const isExpanded = row.getIsExpanded();

  const chevronIcon = () => {
    if (isExpandable && hasSubRows && isExpanded) {
      return <ChevronDown className="text-primary" />;
    }
    if (isExpandable && hasSubRows) {
      return <ChevronRight className="text-primary" />;
    }
    if (isExpandable && !hasSubRows) {
      return <ChevronRight className="text-accent" />;
    }
    return null;
  };

  return (
    <div className="flex items-center justify-center gap-x-2">
      {chevronIcon()}
      {!isExpandable && children}
    </div>
  );
};
